module.exports = __webpack_public_path__ + "static/media/ic_search.1624fe8a.png";